import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_REQUEST,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  CONTRACT_SETUP_FIELD_CREATE,
  CONTRACT_SETUP_FIELD_SIZE_CHANGE,
  CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import FieldType from '@app/store/FieldType';

export interface ContractSetupFieldsSizesState {
  [id: string]: {
    currentScaleHeight: number;
    currentScaleWidth: number;
    relativeHeight: number;
    relativeWidth: number;
  };
}

const initialState: ContractSetupFieldsSizesState = {};

const reducer = produce(
  (draft: Draft<ContractSetupFieldsSizesState>, action: ContractSetupAction) => {
    switch (action.type) {
      case CONTRACT_SETUP_ALL_STATE_CLEAR:
      case CONTRACT_SETUP_BY_DRAFT_REQUEST:
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST:
        return initialState;
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS: {
        const { participantFields } = action.payload;
        participantFields.forEach((participantField) => {
          const { fieldId, guide } = participantField;
          const { sizeWidth, sizeHeight } = guide;
          draft[fieldId] = {
            currentScaleHeight: 0,
            currentScaleWidth: 0,
            relativeHeight: sizeHeight ?? 0,
            relativeWidth: sizeWidth ?? 0,
          };
        });
        return draft;
      }
      case CONTRACT_SETUP_FIELD_CREATE: {
        const { currentScaleHeight, currentScaleWidth, uuid } = action.payload.meta;
        draft[uuid] = {
          currentScaleHeight,
          currentScaleWidth,
          relativeHeight: 0,
          relativeWidth: 0,
        };
        return draft;
      }
      case CONTRACT_SETUP_FIELD_SIZE_CHANGE: {
        const { currentScaleHeight, currentScaleWidth, id, relativeHeight, relativeWidth } =
          action.payload;
        draft[id] = {
          currentScaleHeight,
          currentScaleWidth,
          relativeHeight,
          relativeWidth,
        };
        return draft;
      }
      case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
        const { participants } = action.payload;
        participants.forEach((participant) => {
          const { fields } = participant;
          fields.forEach((field) => {
            switch (field.type) {
              case FieldType.CHECKBOX_GROUP:
                draft[field.id] = {
                  currentScaleHeight: 0,
                  currentScaleWidth: 0,
                  relativeHeight: field.size.height,
                  relativeWidth: field.size.width,
                };
                break;
              case FieldType.SIGNATURE_FIELD:
                draft[field.id] = {
                  currentScaleHeight: 0,
                  currentScaleWidth: 0,
                  relativeHeight: 0,
                  relativeWidth: 0,
                };
                break;
              case FieldType.TEXT_FIELD:
                draft[field.id] = {
                  currentScaleHeight: 0,
                  currentScaleWidth: 0,
                  relativeHeight: field.size.height,
                  relativeWidth: field.size.width,
                };
                break;
              default:
                break;
            }
          });
        });
        return draft;
      }
      case CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE: {
        const { fieldIds } = action.payload;
        fieldIds.forEach((key) => {
          if (key in draft) {
            delete draft[key];
          }
        });
        return draft;
      }
      default:
        return draft;
    }
  },
  initialState
);

export default reducer;
